import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  "navs": []
};

export const navSlice = createSlice({
  name: 'navs',
  initialState,
  reducers: {
    addNavigation: (state, action) => {
      if (!state.navs.includes(action.payload)) {
        state.navs.push(action.payload);
      }
    },
    resetNavigation: (state, action) => {
      state.navs = [];
    },
  },
});

export const { 
  addNavigation,
  resetNavigation,
} = navSlice.actions;

export const getNavigations = (state) => state.navs;

export default navSlice.reducer;
